export const ROOT = 'abtest';
export const CHILD = 'abtest/item';
export const JOIN = 'join';
export const PROBE = 'probe';
export const TEXT = 'text';
export const BUTTON = 'button';
